<template>
  <div id="layout-wrapper">
    <div id="layout-body">
      <div class="game-component">
        <div class="frame-grid">
          <div class="grid-header" />
          <div class="grid-content">
            <div id="game-wrapper">
              <div
                v-if="text!==''"
                ref="newsTicker"
                class="news-ticker-frame"
                :class="{ active: isNewsTickerActive }"
                :style="newsTickerStyle"
              >
                <div class="icon-news-ticker">
                  <img :src="$getThemeImagePath('icon-news-w.png')">
                </div>
                <div class="news-content">
                  <span ref="scrollingText" class="scrolling-text">{{ text }}</span>
                </div>
                <div class="icon-expand" @click="toggleNewsTickerActive" />
              </div>
              <iframe
                v-if="gameUrlFromStore"
                id="iframebox"
                ref="gameIframe"
                :src="gameUrlFromStore"
                :style="{ paddingBottom: iframePaddingBottom }"
              />
            </div>
          </div>
          <div class="grid-footer">
            <div class="game-menu">
              <div class="game-buttons">
                <div class="game-menu-item gm-btn-curr link-item cur-inGame-set" @click="toggleDrawer('currency', $event)">
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.in_play') }}</span>
                  </div>

                  <div class="currency-SelectedFrame cur-inGame">
                    <div class="cur-selected">
                      <img :src="getCurrencyImagePath(getCurrentCurrencyDisplay())" alt="JPY">
                      <b class="">{{ getCurrentCurrencyDisplay() }}</b>
                    </div>
                  </div>
                  <div v-if="isCurrencyDrawerOpen" class="drawer">
                    <div class="drawer-frame cur-inGame-drawer-frame">
                      <div class="drawer-grid amount-box cur-inGame-drawer">
                        <div class="drawer-wallet-title">
                          {{ $t('Bao.select_currency') }}
                          <span v-if="isCurrencyChangeInProgress" class="loading-indicator">({{ $t('Bao.loading') }})</span>
                        </div>
                        <hr class="seperation">
                        <div class="currency-SelectOptionFrame">
                          <div
                            v-for="currency in availableCurrencies"
                            :key="currency"
                            :class="{
                              active: selectedCurrency === currency,
                              disabled: isCurrencyChangeInProgress
                            }"
                            class="cur-option"
                            @click="handleCurrencySelection(currency, $event)"
                          >
                            <img
                              :src="getCurrencyImagePath(currency)"
                              width="20"
                              height="20"
                              alt=""
                            >
                            <b>{{ currency }}</b>
                          </div>
                        </div>
                      </div>
                      <div class="drawer-grid drawer-close-btn">
                        <div class="drawer-wallet-close">
                          <div class="dw-btn-close" @click="toggleDrawer('currency', $event)">
                            ✕
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PLAYED GAMES -->
                <div v-if="!isFromKYCVerify" class="game-menu-item gm-btn-2 link-item ">
                  <div class="game-menu-item-icon" @click="toggleDrawer('history', $event)">
                    <img :src="$getThemeImagePath('history.png')" alt="">
                  </div>
                  <div class="game-menu-item-text" @click="toggleDrawer('history', $event)">
                    <span class="btn-text">{{ $t('Bao.record') }}</span>
                  </div>

                  <!-- drawer Start -->

                  <div v-if="isHistoryDrawerOpen" class="drawer">
                    <div class="drawer-frame cur-inGame-drawer-frame">
                      <div class="gameframe-card-background">
                        <div class="iframe-game-arrow side-previous" @click="scrollGameCardList('left')">
                          &#x276E;
                        </div>
                        <div class="iframe-game-arrow side-next" @click="scrollGameCardList('right')">
                          &#x276F;
                        </div>
                        <div class="iframe-game-arrow drawer-close" @click="toggleDrawer('history', $event)">
                          &#10005;
                        </div>
                        <div class="drawer-2-title">
                          <span class="title-text">{{ $t('Bao.record') }}</span>
                        </div>
                        <div ref="gameCardList" class="gameframe-card-list">
                          <div v-for="(game, key) in filterResult.slice(0, 40) " :key="key" class="gameframe-card" :class="{ active: game.showDetail }">
                            <div class="gameframe-card-image" @click="handleLaunchGame(game)">
                              <picture>
                                <img
                                  :src="game.image"
                                  alt="Game Record Images"
                                >
                              </picture>
                            </div>

                            <i class="game-info-icon" />

                            <div class="gameframe-card-name">
                              <span class="game-name" @click="handleLaunchGame(game)">{{ game.name }}</span>
                              <span class="game-provider">{{ game.game_provider_name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- DEPOSIT-->
                <div v-if="!isFromKYCVerify && $store.getters.canMemberDeposit" class="game-menu-item gm-btn-3 link-item" @click="toggleDrawer('deposit', $event)">
                  <div class="game-menu-item-icon">
                    <img :src="$getThemeImagePath('top_up.png')" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.deposit') }}</span>
                  </div>

                  <!-- drawer Start -->
                  <div v-if="isDepositDrawerOpen" class="drawer deposit-box">
                    <a class="iframe-game-arrow drawer-close">✕</a>
                    <div class="drawer-frame">
                      <div class="drawer-deposit">
                        <h6 class="deposit-subtitle">
                          {{ $t('Bao.deposit') }}
                        </h6>
                      </div>
                      <div class="drawer-deposit">
                        <p class="deposit-text">
                          {{ $t('Bao.deposit_quick') }}
                        </p>
                      </div>
                      <div class="drawer-deposit" @click="handleDepositClick">
                        <button class="btn btn-stroke lengthen">
                          {{ $t('Bao.deposit_action') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- drawer End -->
                </div>

                <!-- ADD FAVORITES -->
                <div v-if="!isFromKYCVerify" class="game-menu-item link-item" @click.stop="handleFavoriteGame($store.state.app.currentGame)">
                  <div class="game-menu-item-icon" :class="{ active:$store.state.app.currentGame.isFavorite }">
                    <img :src="$getThemeImagePath('collect.png')" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span v-if="$store.state.app.currentGame.isFavorite" class="btn-text"> {{ $t('Bao.remove_fav') }}</span>
                    <span v-if="!$store.state.app.currentGame.isFavorite" class="btn-text"> {{ $t('Bao.add_fav') }}</span>
                  </div>
                </div>

                <!-- EXIT -->
                <div class="game-menu-item link-item" @click="clearGameUrl()">
                  <div class="game-menu-item-icon">
                    <img :src="$getThemeImagePath('leave.png')" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.exit') }}</span>
                  </div>
                </div>

                <!-- HELP -->
                <div v-if="!isFromKYCVerify" class="game-menu-item link-item" @click="goHelpCenter">
                  <div class="game-menu-item-icon">
                    <img :src="$getThemeImagePath('headset.png')" alt="">
                  </div>
                  <div class="game-menu-item-text">
                    <span class="btn-text">{{ $t('Bao.headset') }}<span />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gameEnd, launchGameWithProviderInfo, continueGameLaunchWithCurrency } from '@/utils/games'
import { addFavoriteGame, removeFavoriteGame } from '@/api/user'
import { showToast, handleHelpCenterLink, detectMob } from '@/utils/tool'
import { mapGetters } from 'vuex'
export default {
  name: 'GameModal',
  props: {
    allGame: {
      type: Array,
      default: () => { return [] }
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      favoriteGames: [],
      isHistoryDrawerOpen: false,
      isDepositDrawerOpen: false,
      isCurrencyDrawerOpen: false,
      showDetail: false,
      isNewsTickerActive: false,
      newsTickerStyle: {
        left: '0px'
      },
      scrollPosition: 0,
      animationFrameId: null,
      isScrolling: true,
      availableCurrencies: [],
      selectedCurrency: ''
    }
  },
  computed: {
    ...mapGetters(['gameIdsArray', 'token']),
    gameIdSet() {
      return new Set(this.gameIdsArray.map(gameObj => gameObj.game_id))
    },
    gameUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    user() {
      return this.$store.state.user
    },
    banner() {
      return this.$store.state.brand.banners[0]
    },
    filterResult() {
      if (this.gameIdSet.size === 0) { // 沒有遊玩紀錄，顯示全部遊戲
        return this.allGame
      } else { // 顯示遊玩紀錄
        return this.$store.state.game.gameRecords // gamelist API資料
      }
    },
    isFromKYCVerify() {
      return this.user.isFromKYCVerify
    },
    isCurrencyChangeInProgress() {
      return this.$store.state.app.isCurrencyChangeInProgress
    },
    iframePaddingBottom() {
      // Only apply dynamic padding on mobile devices
      if (!detectMob()) {
        return '50px' // Default padding for desktop
      }

      // Calculate dynamic padding based on drawer state for mobile devices
      const basePadding = 50 // Base padding for game menu

      if (this.isHistoryDrawerOpen) {
        return `${basePadding + 320}px` // 350px additional padding for history drawer
      } else if (this.isDepositDrawerOpen || this.isCurrencyDrawerOpen) {
        return `${basePadding + 90}px` // 100px additional padding for deposit/currency drawers
      }

      return `${basePadding}px` // Default padding when no drawer is open
    },
    walletSwitchRequest() {
      return this.$store.state.app.walletSwitchRequest
    }
  },
  watch: {
    walletSwitchRequest: {
      handler(payload) {
        if (!payload || !payload.wallet) return
        this.clearGameUrl()
      }
    },
    gameUrlFromStore(newVal, oldVal) {
      if (newVal !== oldVal) {
        const headerElement = document.querySelector('header')
        if (newVal) {
          headerElement.style.display = 'none'
          this.disableScrolling()
        } else {
          this.enableScrolling()
          headerElement.style.display = window.innerWidth < 992 ? 'block' : 'none'
        }
      }
    },

    '$store.state.app.gameUrl'(newVal) {
      if (!newVal) {
        gameEnd(this.$store.state.app.inGameId)
        this.$store.commit('SET_PENDING_GAME_DATA', null)
      }
    },
    '$store.state.app.currentGame.id'(newId, oldId) {
      if (newId !== oldId) {
        setTimeout(() => {
          this.initCurrencySelection()
        }, 3000)
      }
    },
    selectedCurrency(newCurrency, oldCurrency) {
      if (newCurrency !== oldCurrency && newCurrency) {
        // Force component update when currency changes
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    // Watch for drawer state changes to update iframe padding
    isHistoryDrawerOpen() {
      this.$nextTick(() => {
        // Force iframe to recalculate layout
        if (this.$refs.gameIframe) {
          this.$refs.gameIframe.style.paddingBottom = this.iframePaddingBottom
        }
      })
    },
    isDepositDrawerOpen() {
      this.$nextTick(() => {
        if (this.$refs.gameIframe) {
          this.$refs.gameIframe.style.paddingBottom = this.iframePaddingBottom
        }
      })
    },
    isCurrencyDrawerOpen() {
      this.$nextTick(() => {
        if (this.$refs.gameIframe) {
          this.$refs.gameIframe.style.paddingBottom = this.iframePaddingBottom
        }
      })
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.clearGameUrl)
    this.startScrolling()
    // Initialize currency selection on mount
    this.initCurrencySelection()
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.clearGameUrl)
    this.stopScrolling()
  },

  methods: {
    async handleFavoriteGame(game) {
      const gameInfo = {
        type: 'game',
        data: JSON.stringify([{
          brand_id: this.user.goldInfo.brand_id,
          game_id: game.id
        }])
      }
      try {
        const response = game.isFavorite
          ? await removeFavoriteGame(gameInfo)
          : await addFavoriteGame(gameInfo)

        this.favoriteGames = response.data.data.game
        this.$store.commit('SET_FAVORITE_GAME', this.favoriteGames)
        this.updateGameListLocally(game, !game.isFavorite)
      } catch (error) {
        console.error(error)
      }
    },
    // 顯示彈窗訊息
    showToast(game, isFavorite) {
      const message = isFavorite ? `${game.name} ${this.$t('Bao.favorite')}` : `${game.name} ${this.$t('Bao.favorite_remove')}`
      showToast(message)
      setTimeout(() => {
        this.$store.commit('SET_TOAST_MESSAGE', null)
      }, 3000)
    },
    updateGameListLocally(game, isFavorite) {
      this.showToast(game, isFavorite)
      this.updateFavoriteStatus(game, isFavorite)
    },
    // 點擊愛心後，比對個別遊戲id，增刪"isFavorite" property
    updateFavoriteStatus(game, isFavorite) {
      const updatedGame = {
        ...game,
        isFavorite: isFavorite // Set the isFavorite property to the new value
      }
      this.$store.commit('SET_CURRENT_GAME', updatedGame)
    },
    async handleLaunchGame(game) {
      try {
        // Get the currently selected currency from the current game
        let currentSelectedCurrency = this.getCurrentCurrencyDisplay()

        // If no currency is selected, try to get it from the current game or default to JPY
        if (!currentSelectedCurrency) {
          const currentGame = this.$store.state.app.currentGame
          if (currentGame && currentGame.currency_in_game) {
            const currencies = Array.isArray(currentGame.currency_in_game)
              ? currentGame.currency_in_game
              : String(currentGame.currency_in_game).split(',').map(c => c.trim()).filter(Boolean)
            currentSelectedCurrency = currencies.includes('JPY') ? 'JPY' : currencies[0]
          } else {
            currentSelectedCurrency = 'JPY' // Default fallback
          }
        }

        // Set up the game with provider info and launch with current currency
        await launchGameWithProviderInfo(game, currentSelectedCurrency)

        // Close all drawers
        this.isHistoryDrawerOpen = false
        this.isDepositDrawerOpen = false
        this.isCurrencyDrawerOpen = false
      } catch (error) {
        console.error('Error launching game:', error)
        // Optionally show error message to user
        this.$store.commit('SET_LOADING', false)
      }
    },
    scrollGameCardList(direction) {
      const gameCardList = this.$refs.gameCardList
      const scrollAmount = 260

      if (direction === 'right') {
        gameCardList.scrollTop -= 10
        gameCardList.scrollLeft += scrollAmount
      } else {
        gameCardList.scrollTop += 10
        gameCardList.scrollLeft -= scrollAmount
      }
    },
    clearGameUrl() {
      this.$store.commit('SET_KYC_VERIFY', false)
      this.$store.commit('SET_GAME_URL', null)

      this.$store.state.app.tempGameUrl = ''
      this.isHistoryDrawerOpen = false
      this.isDepositDrawerOpen = false
      this.isCurrencyDrawerOpen = false
    },
    handleDepositClick() {
      // 會員層級入金停用時不進入存款頁
      if (!this.$store.getters.canMemberDeposit) return
      this.clearGameUrl()
      this.$router.push('/deposit')
    },
    toggleDrawer(drawerType, event) {
      event.stopPropagation()
      if (drawerType === 'history') {
        this.isHistoryDrawerOpen = !this.isHistoryDrawerOpen
        this.isDepositDrawerOpen = false
        this.isCurrencyDrawerOpen = false
      } else if (drawerType === 'deposit') {
        this.isDepositDrawerOpen = !this.isDepositDrawerOpen
        this.isHistoryDrawerOpen = false
        this.isCurrencyDrawerOpen = false
      } else if (drawerType === 'currency') {
        this.isCurrencyDrawerOpen = !this.isCurrencyDrawerOpen
        this.isHistoryDrawerOpen = false
        this.isDepositDrawerOpen = false
      }
    },
    disableScrolling() {
    // Disable scrolling
      document.body.style.overflow = 'hidden'
    },
    enableScrolling() {
    // Enable scrolling
      document.body.style.overflow = ''
    },
    toggleNewsTickerActive() {
      this.isNewsTickerActive = !this.isNewsTickerActive
      this.updateNewsTickerPosition()
    },
    updateNewsTickerPosition() {
      if (this.$refs.newsTicker) {
        const width = this.$refs.newsTicker.offsetWidth
        const actualWidth = Math.min(width, 414)
        this.newsTickerStyle.left = this.isNewsTickerActive
          ? `calc(-${actualWidth}px + 25px)`
          : '0px'
      }
    },
    goHelpCenter() {
      const isGuest = !this.token
      const user = this.user
      const userInfo = this.user.memberInfo
      const vipInfo = this.user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, this.banner, user, userInfo, vipInfo, dateFormatter)
    },
    startScrolling() {
      // If scrolling is already disabled, don't start the animation
      if (!this.isScrolling) return

      const scrollText = () => {
        // Stop animation if scrolling is disabled
        if (!this.isScrolling) return

        // Move text 2 pixels to the left each frame
        this.scrollPosition -= 1 // Adjust speed as needed
        const textElement = this.$refs.scrollingText

        if (textElement) {
          // When text scrolls completely off screen (position is less than negative width),
          // reset position to start from right side again
          if (this.scrollPosition <= -textElement.offsetWidth) {
            this.scrollPosition = textElement.parentElement.offsetWidth
          }
          // Apply the horizontal translation to move the text
          textElement.style.transform = `translateX(${this.scrollPosition}px)`
        }

        // Request next animation frame to continue scrolling
        this.animationFrameId = requestAnimationFrame(scrollText)
      }

      // Start the scrolling animation loop
      scrollText()
    },

    stopScrolling() {
      this.isScrolling = false
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId)
      }
    },
    initCurrencySelection() {
      let availableCurrencies = []

      // Get available currencies from the game
      if (this.$store.state.app.currentGame && this.$store.state.app.currentGame.currency_in_game) {
        const cur = this.$store.state.app.currentGame.currency_in_game
        availableCurrencies = Array.isArray(cur)
          ? cur
          : String(cur).split(',').map(c => c.trim()).filter(Boolean)
      }

      this.availableCurrencies = availableCurrencies

      // Get previously selected currency from localStorage
      const lastSelectedCurrency = localStorage.getItem('lastSelectedGameCurrency')

      // If user has previously selected a currency and it's available for this game
      if (lastSelectedCurrency && availableCurrencies.includes(lastSelectedCurrency)) {
        this.selectedCurrency = lastSelectedCurrency
      } else {
        // Default to JPY if available, otherwise use the first available currency
        this.selectedCurrency = availableCurrencies.includes('JPY')
          ? 'JPY'
          : (availableCurrencies[0] || '')
      }
    },
    changeCurrency() {
      if (!this.selectedCurrency) return
      // Save the new selection to localStorage
      localStorage.setItem('lastSelectedGameCurrency', this.selectedCurrency)

      // Close the drawer first
      this.isCurrencyDrawerOpen = false

      // Show loading state
      this.$store.commit('SET_LOADING', true)
      // Launch game with new currency
      continueGameLaunchWithCurrency(this.selectedCurrency)
    },
    getCurrentCurrencyDisplay() {
      // Return the currently selected currency or the default currency from local storage
      if (this.selectedCurrency) {
        return this.selectedCurrency
      }
      const lastSelectedCurrency = localStorage.getItem('lastSelectedGameCurrency')
      if (lastSelectedCurrency && this.availableCurrencies.includes(lastSelectedCurrency)) {
        return lastSelectedCurrency
      }
      return this.availableCurrencies.includes('JPY') ? 'JPY' : this.availableCurrencies[0] || ''
    },
    getCurrencyImagePath(currency) {
      // Define supported crypto currencies
      const supportedCryptos = [
        'JPY', 'UBD', 'JRA', 'SOL', 'USDT', 'LTC', 'XRP', 'BTC', 'ETH',
        'DOGE', 'BCH', 'TRX', 'BNB', 'USDC', 'SHIB', 'TETH', 'ADA', 'USD', 'CNY', 'TWD'
      ].map(c => c.toLowerCase())
      // Make sure currency is a string and convert to lowercase
      const currencyLower = String(currency).toLowerCase()
      // JPY icon logic: if currency is JPY, show JPY icon
      if (currencyLower === 'jpy') {
        return this.$getThemeImagePath(`icon_jpy.svg`)
      }
      // Check if the currency is supported
      if (supportedCryptos.includes(currencyLower)) {
        return this.$getThemeImagePath(`crypto-${currencyLower}.svg`)
      } else {
        // Return default image for unsupported cryptocurrencies
        return this.$getThemeImagePath(`default-crypto.svg`)
      }
    },
    handleCurrencySelection(currency, event) {
      event.stopPropagation()
      if (this.isCurrencyChangeInProgress) {
        return
      }
      this.selectedCurrency = currency
      this.changeCurrency()
    }
  }
}
</script>

<style scoped>
.loading-indicator {
  color: #ffc107;
  font-size: 0.9em;
  margin-left: 8px;
}
</style>
